import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgIcBaselinePlus = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6z" />
  </svg>
);
const ForwardRef = forwardRef(SvgIcBaselinePlus);
const Memo = memo(ForwardRef);
export default Memo;
